import { useState } from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import { company } from '../data';
import { Container, Reveal, SectionHead } from './ui';

const field =
  'w-full rounded-lg bg-white/5 border border-white/15 px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/40';

const ServiceOptions = ['ACB Servicing', 'VFD Installation & Commissioning', 'PLC & HMI Programming', 'Digitization & IoT', 'Something else'];

const Contact = () => {
  const [sent, setSent] = useState(false);

  // No backend: the form opens the visitor's mail app with the enquiry filled in.
  const onSubmit = (e) => {
    e.preventDefault();
    const d = Object.fromEntries(new FormData(e.target));
    const subject = `Enquiry: ${d.service} - ${d.company || d.name}`;
    const body = `Name: ${d.name}\nCompany: ${d.company}\nPhone: ${d.phone}\nEmail: ${d.email}\n\n${d.message}`;
    window.location.href = `mailto:${company.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setSent(true);
  };

  return (
    <section id="contact" className="relative bg-ink grid-bg text-white py-20 md:py-28 scroll-mt-24">
      <Container className="grid lg:grid-cols-5 gap-12">
        <Reveal className="lg:col-span-2">
          <SectionHead
            light
            eyebrow="Contact"
            title="Tell us what's tripping, tuning or missing."
            text="Breakdown, planned shutdown or a new project: send us the details and we'll get back to you."
          />
          <ul className="mt-10 space-y-5 text-white/85">
            <li className="flex gap-4"><FaPhoneAlt className="mt-1 text-primary shrink-0" /><a className="hover:text-white" href={company.phoneHref}>{company.phone}</a></li>
            <li className="flex gap-4"><FaEnvelope className="mt-1 text-primary shrink-0" /><a className="hover:text-white" href={`mailto:${company.email}`}>{company.email}</a></li>
            <li className="flex gap-4"><FaMapMarkerAlt className="mt-1 text-primary shrink-0" /><span>{company.address}</span></li>
          </ul>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-3">
          <form onSubmit={onSubmit} className="rounded-2xl bg-panel border border-white/10 p-6 md:p-8 grid sm:grid-cols-2 gap-4">
            <label className="block"><span className="sr-only">Full name</span><input required name="name" className={field} placeholder="Full name" /></label>
            <label className="block"><span className="sr-only">Company</span><input name="company" className={field} placeholder="Company" /></label>
            <label className="block"><span className="sr-only">Email</span><input required type="email" name="email" className={field} placeholder="Email" /></label>
            <label className="block"><span className="sr-only">Phone</span><input name="phone" className={field} placeholder="Phone" /></label>
            <label className="block sm:col-span-2">
              <span className="sr-only">Service</span>
              <select name="service" className={`${field} [&>option]:text-ink`} defaultValue={ServiceOptions[0]}>
                {ServiceOptions.map((s) => <option key={s}>{s}</option>)}
              </select>
            </label>
            <label className="block sm:col-span-2"><span className="sr-only">Message</span><textarea required name="message" rows={4} className={field} placeholder="Describe the equipment, location and issue" /></label>
            <div className="sm:col-span-2 flex flex-wrap items-center gap-4">
              <button type="submit" className="inline-flex items-center gap-2 rounded-full bg-primary hover:bg-[#0aa0ee] px-7 py-3 font-semibold transition">
                Send enquiry <FaArrowRight />
              </button>
              {sent && <span className="text-sm text-white/60">Your email app should open with the message ready to send.</span>}
            </div>
          </form>
        </Reveal>
      </Container>
    </section>
  );
};

export default Contact;
